import { Button } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import apiList from "./ApiTemplates.json";
import "./SmokeTest.css";

export default function SmokeTest() {
  const apiInput = useRef();
  const tokenInput = useRef();
  const payloadInput = useRef();
  const [httpMethod, setHttpMethod] = useState("POST");
  const [apiUrl, setApiUrl] = useState("");
  const [prettyResponse, setPrettyResponse] = useState("");
  const [showResponse, setShowResponse] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [noPayload, setNoPayload] = useState(true);
  const [accessToken, setAccessToken] = useState("");

  async function getAccessToken() {
    try {
        const {data} = await axios.get(
          `${global.REACT_APP_API_ENDPOINT}/smoketest/getToken`,
          {headers: {Authorization: `Bearer YOUR_ACCESS_TOKEN`}}
        );
        console.log("getAccessToken", data.access_token)
        setAccessToken(data.access_token);
        if (tokenInput.current) {
          tokenInput.current.value = data.access_token;
        }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAccessToken();
  }, []);

  function jsonPrettify(json) {
    const obj = typeof json === "string"
      ? JSON.parse(json)
      : json;
    return JSON.stringify(obj, null, 2);
  };

  function isValidJson(str) {
    try {
      if (typeof str === "object") 
        return true; 

      JSON.parse(str); 
    } 
    catch { return false; }
    return true;
  };

  function showError(element) {
    element.classList.add("has-error");

    setTimeout(() => {
      element.classList.remove("has-error");
    }, 1000);
  };

  function onApiSelect(ev) {
    const apiName = ev.target.value;
    const api = apiList.find(a => a.apiName.toLowerCase() === apiName);
    setPrettyResponse("");
    setShowResponse(false);
    if (api) {
      payloadInput.current.value = api.template?jsonPrettify(api.template):"";
      setHttpMethod(api.httpMethod || "POST");
      setApiUrl(api.endpoint || "");
      if (apiName === "du" || apiName === "ldng") {
        setShowToken(true);
        setTimeout(() => {
          if (tokenInput.current && !tokenInput.current.value) {
            tokenInput.current.value = accessToken;
          }
        }, 200);
      } else {
        setShowToken(false);
      }
    } else {
      payloadInput.current.value = "";
    }
    setNoPayload(payloadInput.current.value === "");
  };

  async function onSubmit(ev) {
    let hasError = false;

    const apiName = apiInput.current.value;
    var payload = payloadInput.current.value;
    var url = "";

    if (!apiName) {
      showError(apiInput.current);
      hasError = true;
    }
    if (apiName === "du" || apiName === "ldng") {
      var accessToken = tokenInput.current.value;
      if (!accessToken) {
        showError(tokenInput.current);
        hasError = true;
      }
      url = `${global.REACT_APP_API_ENDPOINT}/smoketest/validateApi?apiName=${apiName}`;
    } else {
      url = `${global.REACT_APP_API_ENDPOINT}${apiUrl}`;
      accessToken = null;
    }
    if (payload && !isValidJson(payload)) {
      showError(payloadInput.current);
      hasError = true;
    }

    if (!hasError) {

      var jsonPayload = null;
      if (payload) {
        jsonPayload = JSON.parse(payload);
        if (apiName.toLowerCase() === "Expire Active Certification For Unavailable Projects".toLowerCase()) {
          var passData = JSON.parse(sessionStorage.getItem("passData"));
          if (passData && (passData.uid || passData.user)) {
            jsonPayload["updatedBy"] = passData.uid || passData.user;
          }
        } else if (apiName === "du" || apiName === "ldng") {
          // Wrap payload inside 'request' object for DU and LDNG APIs
          jsonPayload = { request: jsonPayload };
        }

      }
      //console.log({apiName, accessToken, payload})
      
      try {
        let response = (httpMethod === "GET") ?
          await axios.get(
            url,
            { headers: accessToken ? { accessToken } : null }
          ): (httpMethod === "POST") ?
          await axios.post(
            url,
            jsonPayload, 
            { headers: accessToken ? { accessToken } : null }
          ) : (httpMethod === "PUT") ? 
          await axios.put(
            url,
            jsonPayload, 
            { headers: accessToken ? { accessToken } : null }
          ): (httpMethod === "DELETE") ?
          await axios.delete(
            url,  
            { headers: accessToken ? { accessToken } : null }
          ): null;
        
        console.log("response", response)
        if (response) {
          var strResponse = response.data || response;
          setPrettyResponse(isValidJson(strResponse) ? jsonPrettify(strResponse) : strResponse);
        } else {
          setPrettyResponse("No Response");
        }
        setShowResponse(true);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div className="smoke-test">
      <div className="field-group">
        <label htmlFor="apiName">Select API</label>
        <select id="apiName" ref={apiInput} name="apiName" onChange={onApiSelect}>
          <option value="">-- Select --</option>
          {apiList
            .filter(api => api.apiName.toLowerCase() !== "lookup")
            .map((api, i) => (
              <option key={i} value={api.apiName.toLowerCase()}>{api.apiName}</option>
          ))}
        </select>
      </div>

      {showToken ? (
        <div className="field-group">
          <label htmlFor="token">Access token</label>
          <textarea id="token" name="token" 
            spellCheck={false} 
            ref={tokenInput}></textarea>

          <div className="button-wrapper">
            <Button type="submit" className="get-token-button" onClick={getAccessToken}>
              Generate Token
              <RefreshIcon />
            </Button>
          </div>
        </div>
      ) : (<></>)}

      <div className="field-group">
        <label htmlFor="payload">Payload</label>
        <textarea id="payload" name="payload" spellCheck={false} readOnly={noPayload} ref={payloadInput}></textarea> 
      </div>

      <div className="button-wrapper">
        <Button type="submit" className="submit-payload-button" onClick={onSubmit}>
          Call API
        </Button>
      </div>

      {showResponse ? (
        <div className="field-group output-section">
          <label htmlFor="output">API Response</label>
          <textarea id="output" name="output" readOnly spellCheck={false} value={prettyResponse}></textarea>
        </div>
      ) : (<></>)}
    </div>
  );
}